import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import AppButton from "../../components/app-button/AppButton";
import AppTable from "../../components/app-table/AppTable";

function AppSubscriptionsAndBillings(props) {
  const plan = {
    name: "Pro",
    expiryDate: "2025-09-16",
    totalDays: 30,
  };

  const tableRows = [
    {
      name: "Pro",
      startDate: "2025-08-15",
      expiryDate: "2025-09-15",
      remainingDays: "20 Days",
      amount: 1180,
      status: "Running", // Add colors for status text
      paymentDate: "2025-08-15",
    },
    {
      name: "Basic",
      startDate: "2025-06-01",
      expiryDate: "2025-07-01",
      remainingDays: "10 Days",
      amount: 590,
      status: "Expired",
      paymentDate: "2025-06-01",
    },
  ];

  const tableHead = [
    { id: "planName", label: "Plan Name", align: "left" },
    { id: "startDate", label: "Start Date", align: "left" },
    { id: "expiryDate", label: "Expiry Date", align: "left" },
    { id: "remainingDays", label: "Remaining Days", align: "left" },
    { id: "amount", label: "Amount (incl. GST)", align: "left" },
    { id: "status", label: "Status", align: "left" },
    { id: "paymentDate", label: "Payment Date", align: "left" },
    { id: "actions", label: "Actions", align: "center" },
  ];

  const storeId = null;

  const today = new Date();
  const expiryDate = new Date(plan.expiryDate);
  const diffTime = expiryDate - today;
  const remainingDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  let statusColor = "success.main";
  let StatusIcon = CheckCircleIcon;
  let statusText = "Active";

  if (remainingDays <= 0) {
    statusColor = "error.main";
    StatusIcon = ErrorIcon;
    statusText = "Expired";
  } else if (remainingDays <= 7) {
    statusColor = "warning.main";
    StatusIcon = AccessTimeIcon;
    statusText = "Expiring Soon";
  }

  const handleDownload = () => {};

  return (
    <Box>
      <Card sx={{ mb: 3, p: 2, borderRadius: 3 }}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography variant="h6" fontWeight={600}>
                {plan.name} Plan
              </Typography>
              <Box display="flex" alignItems="center" gap={1} mt={1}>
                <StatusIcon sx={{ color: statusColor }} />
                <Typography variant="body1" color={statusColor}>
                  {statusText}
                </Typography>
              </Box>
              <Typography variant="body2" mt={1}>
                Expiry Date: <b>{expiryDate.toLocaleDateString("en-IN")}</b>
              </Typography>
              <Typography variant="body2">
                Remaining:{" "}
                <b>{remainingDays > 0 ? `${remainingDays} days` : "0"}</b>
              </Typography>
            </Box>

            {remainingDays <= 7 && (
              <AppButton variant="contained" color="primary">
                Renew Now
              </AppButton>
            )}
          </Box>
        </CardContent>
      </Card>

      <Box>
        <Box mt={2}>
          <Typography variant="h6" mb={2}>
            Subscriptions and Billing
          </Typography>
        </Box>

        <AppTable
          hideSearch={true}
          tableHead={tableHead}
          tableRows={tableRows}
          listType="appSubscriptions"
          searchPlaceholder="Search name"
          downloadActionClick={handleDownload}
          storeId={storeId}
        />
      </Box>
    </Box>
  );
}

export default AppSubscriptionsAndBillings;
